import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Wrench, Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = React.useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/book", label: "Book" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-40 bg-obsidian/85 backdrop-blur-md border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-brand flex items-center justify-center">
            <Wrench className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-black text-lg tracking-tighter">TRADES MECHANICAL</div>
            <div className="text-mono-label">Appliance Repair · NY / CT</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm font-body font-medium link-hover ${loc.pathname === l.to ? "text-brand" : "text-[#475569]"}`}
            >
              {l.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/admin" data-testid="nav-admin" className="text-sm font-body font-medium link-hover text-[#475569]">Dashboard</Link>
              <button
                data-testid="nav-logout"
                onClick={async () => { await logout(); nav("/"); }}
                className="btn-outline"
              >Logout</button>
            </>
          ) : (
            <Link to="/book" data-testid="nav-cta-book" className="btn-brand">Request Service</Link>
          )}
        </nav>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-slate-900" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-surface border-t border-[#E2E8F0] px-6 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-sm py-2 text-[#475569]">{l.label}</Link>
          ))}
          {user ? (
            <>
              <Link to="/admin" onClick={() => setOpen(false)} className="text-sm py-2">Dashboard</Link>
              <button onClick={async () => { setOpen(false); await logout(); nav("/"); }} className="btn-outline">Logout</button>
            </>
          ) : (
            <Link to="/book" onClick={() => setOpen(false)} className="btn-brand text-center">Request Service</Link>
          )}
        </div>
      )}
    </header>
  );
}
